import { jsx } from 'react/jsx-runtime';
import { Flex, themedColor, AccordionProvider, useAccordion } from '@lemonade-hq/cdk';
import styled from 'styled-components';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: solid 1px ",
        ";\n  border-radius: 15px;\n  box-shadow: 0 30px 18px -13px rgba(0, 0, 0, 0.06);\n  padding: 15px 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var AccordionStyledWrapper = styled(Flex).attrs({
    flexDirection: "column"
})(_templateObject(), themedColor("glass"));
var AccordionWrapper = function(_param) {
    var children = _param.children, restProps = _object_without_properties(_param, [
        "children"
    ]);
    var getAccordionProps = useAccordion().getAccordionProps;
    return /*#__PURE__*/ jsx(AccordionStyledWrapper, _object_spread_props(_object_spread({}, getAccordionProps(), restProps), {
        children: children
    }));
};
var Accordion = function(_param) {
    var children = _param.children, restProps = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ jsx(AccordionProvider, _object_spread_props(_object_spread({}, restProps), {
        children: /*#__PURE__*/ jsx(AccordionWrapper, {
            children: children
        })
    }));
};
Accordion.displayName = "Accordion";

export { Accordion, AccordionStyledWrapper };
